import React from 'react'

function MySadirTravels() {
  return (
    <div>
        <h4 className='titles'>נסיעות סדירות</h4>
    </div>
  )
}

export default MySadirTravels